import { Trash2 } from 'lucide-react';

import { Button } from '@apps/web/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';

type CancelShiftButtonProps = {
    readonly onCancel: () => void;
};

export function CancelShiftButton({ onCancel }: CancelShiftButtonProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild={true}>
                <Button
                    variant="ghost"
                    size="icon"
                    className="text-muted-foreground hover:text-destructive h-6 w-6 p-0"
                    onClick={(e) => {
                        e.stopPropagation();
                        onCancel();
                    }}
                    aria-label="Cancel shift"
                >
                    <Trash2 className="h-4 w-4" />
                </Button>
            </TooltipTrigger>
            <TooltipContent>Cancel shift</TooltipContent>
        </Tooltip>
    );
}
